const config = require('../../config');
const Layout = require('../components/layout/index').default;
const routes = require(`./router-${process.env.VUE_APP_NAME}`);

const routesList = routes.concat([
  {
    path: '/repeat-task',
    component: Layout,
    redirect: '/repeat-task/repeat-task',
    children: [
      {
        path: 'repeat-task',
        component: ()=>import('@/pages/repeat-task/repeat-task'),
      },
    ],
  },

  {
    path: '/tour',
    component: ()=>import('@/pages/tour/tour'),
    hidden: true,
  },

  {
    path: '/preview',
    component: ()=>import('@/pages/preview/preview'),
    hidden: true,
  },

  {
    path: '/no-auth',
    component: ()=>import('@/pages/error/no-auth'),
    hidden: true,
  },

  {
    path: '*',
    component: ()=>import('@/pages/error/404'),
  },
]);

if (process.env.NODE_ENV == 'development' && routesList.filter((item) => item.path == '/login').length == 0) {
  routesList.unshift({
    path: '/login',
    component: ()=>import('@/pages/login/login'),
    hidden: true,
  });
}

module.exports = routesList;
